import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 to-slate-50 flex items-center justify-center p-4 relative">
      <Card className="bg-white border border-slate-100 shadow-xl rounded-xl p-12 max-w-md text-center">
        <XCircle className="w-16 h-16 text-slate-400 mx-auto mb-6" strokeWidth={1.5} />
        <h2 className="text-2xl font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Manrope, sans-serif' }}>Paiement annulé</h2>
        <p className="text-slate-600 mb-6">Votre paiement a été annulé. Aucun montant n'a été débité.</p>
        <Button onClick={() => navigate('/')} className="bg-rose-600 hover:bg-rose-700 text-white rounded-lg">
          Retour à l'accueil
        </Button>
      </Card>
      
      {/* Footer */}
      <footer className="absolute bottom-4 left-0 right-0">
        <div className="flex justify-center items-center gap-4 text-xs text-slate-400">
          <Link to="/politique-de-confidentialite" className="hover:text-rose-600 transition-colors">
            Politique de confidentialité
          </Link>
          <span>•</span>
          <Link to="/mentions-legales" className="hover:text-rose-600 transition-colors">
            Mentions légales
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default PaymentCancel;
